import i18n from '@/plugins/i18n';

export const initialFilter = () => {
    return {
      page: 1,
      limit:10,
      search: null,
      start: null,
      end: null,
    }
}
export const tabLabel = (type) => {
  return [
      {
          value: 0,
          code: 'all',
          text: i18n.t('All'),
          icon: 'fa-regular fa-earth-asia',
          badge: 'badge badge-dark',
          count:0
      },
  ];
}


// WEBPACK FOOTER //
// ./src/layouts/tenancy/admin/Params.js